import { Manufacturer } from '@/services/api/contracts/catalog/types';
import { useManufacturers } from '@/services/api/hooks/catalog';
import { useCatalogueExplorerFilterService } from '@/services/catalogue/useCatalogueExplorerFilterService';
import { FunctionComponent, useMemo, useState } from 'react';

interface MappedManufacturer extends Manufacturer {
  checked: boolean;
}

interface CatalogueExplorerFilterManufacturersProps {
  onChange: (manufacturers: Manufacturer[]) => void;
}

const CatalogueExplorerFilterManufacturers: FunctionComponent<CatalogueExplorerFilterManufacturersProps> = ({
  onChange
}) => {
  const [manufacturers] = useManufacturers();

  const filters = useCatalogueExplorerFilterService(state => state.manufacturerFilters);

  const mapInitialManufacturers = manufacturers.map(item => ({
    ...item,
    checked: !!filters.find(filter => filter.id === item.id)
  })) as MappedManufacturer[];

  const [mappedManufacturers, setMappedManufacturers] = useState(mapInitialManufacturers);

  const onCheckCallback = (manufacturerId: string) => {
    const lookup = mappedManufacturers.find(item => item.id === manufacturerId);

    if (!lookup) throw new Error('Missing manufacturer');

    lookup.checked = !lookup.checked;
    setMappedManufacturers([...mappedManufacturers]);

    const checkedItems = mappedManufacturers
      .filter(item => item.checked)
      .map(item => {
        return { id: item.id, name: item.name } as Manufacturer;
      });
    onChange(checkedItems);
  };

  const filteredManufacturerCount = useMemo(() => {
    return mappedManufacturers.filter(item => item.checked).length;
  }, [filters]);

  return (
    <div className="space-y-1">
      <p className="text-lg font-medium mb-2">
        Manufacturers {filteredManufacturerCount > 0 && `(${filteredManufacturerCount})`}
      </p>
      <div className="flex flex-col gap-1 max-h-[20rem] overflow-auto">
        <div className={'grid grid-cols-3 gap-2 px-3'}>
          {mappedManufacturers.map(manufacturer => (
            <div
              key={manufacturer.id}
              className="flex space-x-2 items-center"
              onClick={() => onCheckCallback(manufacturer.id)}
            >
              <input checked={manufacturer.checked} className="w-4 h-4" type="checkbox" />
              <p className="text-md">{manufacturer.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CatalogueExplorerFilterManufacturers;
